import React, {useState, useEffect, useCallback} from "react";
import ProgramBasics from "../components/Forms/ProgramBasic";
import {Tabs, TabsHeader, TabsBody, Tab} from "@material-tailwind/react";
import Session from "../components/Forms/ProgramSession";
import Question from "../components/Forms/ProgramQuestion";
import CounsellingSessions from "../components/Forms/ProgramCounsellingSlots";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

export default function Program() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<number>(0);
    const [programId, setProgramId] = useState<string | undefined>();
    const [startDate, setStartDate] = useState<string | undefined>();
    const [hasCounselling, setHasCounselling] = useState<boolean>(true);

    useEffect(() => {
        // Clear any stale program ID when initiating a new program
        localStorage.removeItem('programId');
        localStorage.removeItem('startDate');
    }, []);

    const updateProgramId = (programIdAdded: string) => {
        if (programIdAdded) {
            setProgramId(programIdAdded);
        }
    };
    const updateStartDate = (allStartDate: string) => {
        if (allStartDate) {
            setStartDate(allStartDate);
        }
    };
    const updateHasCounselling = useCallback((value: boolean) => {
        setHasCounselling(value);
    }, []);
    

    const handleTabChange = (index: number) => {
        const newProgramId = programId ? programId : localStorage.getItem('programId')
         
        if (index !== 0 && !newProgramId) {
            toast.warning(t("adminPrograms.fillBasicsWarning", "Please fill out program basic details before proceeding"));
        } else {
            setActiveTab(index);
        }
    };

    const chnageTab = (index: number) => {
        setActiveTab(index);
    };
    return (
        <>
            <h2 className="py-1 pb-4 text-2xl font-gilroy font-semibold text-[#263238]">
                {t("adminPrograms.addProgramTitle", "Add New Program")}
            </h2>
            <div className="bg-white h-[calc(100vh-190px)] overflow-y-hidden rounded-md py-2">
                <Tabs>
                    <TabsHeader className="border-b-2  rounded-none mx-6 ">
                        <Tab
                            key="Basic"
                            value="Basic"
                            onClick={() => handleTabChange(0)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1] ${
                                activeTab === 0 ? "active" : ""
                            }  `}
                        >
                            {t("adminPrograms.tabs.basic", "Basic")}
                        </Tab>
                        <Tab
                            key="Sessions"
                            value="Sessions"
                            onClick={() => handleTabChange(1)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${
                                activeTab === 1 ? "active" : ""
                            }  `}
                        >
                            {t("adminPrograms.tabs.sessions", "Sessions")}
                        </Tab>
                        <Tab
                            key="Question"
                            value="Question"
                            onClick={() => handleTabChange(2)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${
                                activeTab === 2 ? "active" : ""
                            }  `}
                        >
                            {t("adminPrograms.tabs.questions", "Questions")}
                        </Tab>
                        <Tab
                            key="Counselling"
                            value="Counselling"
                            onClick={() => handleTabChange(3)}
                            className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 border-[#ECEFF1]  ${
                                activeTab === 3 ? "active" : ""
                            } ${!hasCounselling ? "hidden" : ""} `}
                        >
                            {t("adminPrograms.tabs.counselling", "1-1 Counselling")}
                        </Tab>
                    </TabsHeader>

                    <TabsBody>
                        <div className={`tab-panel ${activeTab === 0 ? "active block" : "hidden"}`}>
                            <ProgramBasics
                                chnageTab={() => chnageTab(1)}
                                updateProgramId={updateProgramId}
                                updateStartDate={updateStartDate}
                                updateHasCounselling={updateHasCounselling}
                                programId={programId}
                            />
                        </div>
                        <div className={`tab-panel ${activeTab === 1 ? "active block" : "hidden"}`}>
                            <Session programId={programId} startDate={startDate}/>
                        </div>
                        <div className={`tab-panel ${activeTab === 2 ? "active block" : "hidden"}`}>
                            <Question programId={programId}/>
                        </div>
                        <div className={`tab-panel ${activeTab === 3 ? "active block" : "hidden"}`}>
                            <CounsellingSessions programId={programId}/>
                        </div>
                    </TabsBody>
                </Tabs>
            </div>
        </>
    );
}
